import React from 'react';
import { CollectionFilterOptions, CollectionStatus } from '../../types/collections';

interface CollectionFiltersProps {
  filters: CollectionFilterOptions;
  onFilterChange: (filters: Partial<CollectionFilterOptions>) => void;
}

const CollectionFilters: React.FC<CollectionFiltersProps> = ({ filters, onFilterChange }) => {
  const statuses: (CollectionStatus | 'All')[] = ['All', 'Pending', 'Sent', 'Paid', 'Overdue'];

  const handleStatusChange = (status: CollectionStatus | 'All') => {
    onFilterChange({ status: status });
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange({ search: event.target.value });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
      <div style={{ display: 'flex', gap: '8px' }}>
        {statuses.map((status) => (
          <button
            key={status}
            onClick={() => handleStatusChange(status)}
            style={{
              padding: '8px 16px',
              backgroundColor: filters.status === status ? '#f3f4f6' : '#ffffff',
              border: '1px solid',
              borderColor: filters.status === status ? '#d1d5db' : '#e5e7eb',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: '14px',
              color: filters.status === status ? '#111827' : '#374151',
              transition: 'all 0.15s ease',
              boxShadow: filters.status === status ? 'inset 0 1px 2px rgba(0,0,0,0.05)' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
            }}
          >
            {status}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CollectionFilters; 